import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mic2 } from "lucide-react";
import Playbook from "@/components/Playbook";
import { api } from "@/lib/api";
import { readApiError } from "@/lib/format";

export default function AdminLaunchKit() {
  const [voice, setVoice] = useState(null);
  const [rendering, setRendering] = useState(false);

  const renderVoiceover = async (blocks) => {
    const script = (blocks || []).find((b) => b.slug === "script");
    if (!script || !script.body) {
      toast.error("Generate the launch kit first — the 60s script is needed to voice.");
      return;
    }
    setRendering(true);
    try {
      const r = await api.post("/admin/playbooks/launch_kit/render-voiceover");
      setVoice(r.data);
      toast.success("Voiceover ready", {
        description: `${r.data.voice_name} · ~${Math.round(r.data.duration_estimate_sec || 0)}s`,
      });
    } catch (e) {
      toast.error("Voiceover failed", { description: readApiError(e) });
    } finally {
      setRendering(false);
    }
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const extraActions = ({ blocks }) => (
    <button
      type="button"
      onClick={() => renderVoiceover(blocks)}
      disabled={rendering || !(blocks || []).length}
      data-testid="launch-render-voiceover"
      className="inline-flex items-center gap-2 rounded-md border border-[#7A8B6F] bg-[#7A8B6F] px-4 py-2 text-sm text-[#F5EFE2] transition-colors hover:bg-[#8B9C80] disabled:cursor-not-allowed disabled:opacity-40"
    >
      {rendering ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Mic2 className="h-4 w-4" />
      )}
      Render Daniel Voiceover
    </button>
  );

  return (
    <div className="space-y-6">
      <Playbook
        kind="launch_kit"
        eyebrow="Launch Video Kit"
        headline="60 seconds. Six shots. Kenny's voice."
        tagline="Script, storyboard, music picks, and export checklist. When the script's ready, render it in Daniel with one click."
        emptyCTA="Draft the whole launch kit"
        extraActions={extraActions}
      />

      {voice && (
        <div
          data-testid="launch-voice-result"
          className="rounded-2xl border border-[#7A8B6F]/50 bg-[#5A5347] p-5"
        >
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[#C9A961]">
              <Mic2 className="h-3.5 w-3.5" />
              Launch script voiceover · {voice.voice_name} · ~
              {Math.round(voice.duration_estimate_sec || 0)}s
            </div>
            <a
              href={`data:audio/mpeg;base64,${voice.audio_base64}`}
              download="coastal-roots-launch.mp3"
              className="text-xs text-[#C9A961] hover:underline"
              data-testid="launch-voice-download"
            >
              Download MP3
            </a>
          </div>
          <audio
            data-testid="launch-voice-audio"
            controls
            src={`data:audio/mpeg;base64,${voice.audio_base64}`}
            className="w-full"
          />
        </div>
      )}
    </div>
  );
}
